import {
    getAuthorListingRepo,
    getAuthorDataRepo,
    getAuthorFilterRepo,
    getLocationDataRepo,
    postAuthorProfileRepo,
    putAuthorProfileRepo,
    deleteAuthorProfileRepo
} from "../repositories/authorProfile";
import { createSlice } from "@reduxjs/toolkit";
const authorSlice = createSlice({
    name: "authorReducer",
    initialState: {
        authorListingLoading: false,
        authorListingData: null,
        authorListingError: null,
        authorDataLoading: false,
        authorData: null,
        authorDataError: null,
        entitySearchListLoading: false,
        entitySearchListData: null,
        entitySearchListError: null,
        locationDataLoading: false,
        locationData: null,
        locationDataError: null,
        userDataLoading: false,
        userData: null,
        userDataError: null,
        postAuthorProfileData: null,
        postAuthorProfileError: null,
        putAuthorProfileData: null,
        putAuthorProfileError: null,
        deleteAuthorProfileDataLoading: false,
        deleteAuthorProfileData: null,
        deleteAuthorProfileError: null
    },
    reducers: {
        getAuthorListingLoading(state, action) {
            return {
                ...state,
                authorListingLoading: true,
            };
        },
        getAuthorListingSuccess(state, action) {
            return {
                ...state,
                authorListingLoading: false,
                authorListingData: action.payload,
            };
        },
        getAuthorListingFailure(state, action) {
            return {
                ...state,
                authorListingLoading: false,
                authorListingError: action.payload,
            };
        },
        clearAuthorListingResponse(state, action) {
            return {
                ...state,
                authorListingData: null,
            };
        },
        getAuthorDataLoading(state, action) {
            return {
                ...state,
                authorDataLoading: true,
            };
        },
        getAuthorDataSuccess(state, action) {
            return {
                ...state,
                authorDataLoading: false,
                authorData: action.payload,
            };
        },
        getAuthorDataFailure(state, action) {
            return {
                ...state,
                authorDataLoading: false,
                authorDataError: action.payload,
            };
        },
        clearAuthorDataResponse(state, action) {
            return {
                ...state,
                authorData: null,
            };
        },
        getEntitySearchListLoading(state, action) {
            return {
                ...state,
                entitySearchListLoading: true,
            };
        },
        getEntitySearchListSuccess(state, action) {
            return {
                ...state,
                entitySearchListLoading: false,
                entitySearchListData: action.payload,
            };
        },
        getEntitySearchListFailure(state, action) {
            return {
                ...state,
                entitySearchListLoading: false,
                entitySearchListError: action.payload,
            };
        },
        clearEntitySearchListResponse(state, action) {
            return {
                ...state,
                entitySearchListLoading: false,
                entitySearchListData: null,
            };
        },
        getLocationDataLoading(state, action) {
            return {
                ...state,
                locationDataLoading: true,
            };
        },
        getLocationDataSuccess(state, action) {
            return {
                ...state,
                locationDataLoading: false,
                locationData: action.payload,
            };
        },
        getLocationDataFailure(state, action) {
            return {
                ...state,
                locationDataLoading: false,
                locationDataError: action.payload,
            };
        },
        getUserDataLoading(state, action) {
            return {
                ...state,
                userDataLoading: true,
            };
        },
        getUserDataSuccess(state, action) {
            return {
                ...state,
                userDataLoading: false,
                userData: action.payload,
            };
        },
        getUserDataFailure(state, action) {
            return {
                ...state,
                userDataLoading: false,
                userDataError: action.payload,
            };
        },
        postAuthorProfileSuccess(state, action) {
            return {
                ...state,
                postAuthorProfileData: action.payload,
            };
        },
        postAuthorProfileFailure(state, action) {
            return {
                ...state,
                postAuthorProfileError: action.payload,
            };
        },
        clearPostAuthorProfileResponse(state, action) {
            return {
                ...state,
                postAuthorProfileData: null,
                postAuthorProfileError: null,
                userData: null
            };
        },
        putAuthorProfileSuccess(state, action) {
            return {
                ...state,
                putAuthorProfileData: action.payload,
            };
        },
        putAuthorProfileFailure(state, action) {
            return {
                ...state,
                putAuthorProfileError: action.payload,
            };
        },
        clearPutAuthorProfileResponse(state, action) {
            return {
                ...state,
                putAuthorProfileData: null,
                putAuthorProfileError: null,
            };
        },
        deleteAuthorProfileLoading(state, action) {
            return {
                ...state,
                deleteAuthorProfileDataLoading: null,
            };
        },
        deleteAuthorProfileSuccess(state, action) {
            return {
                ...state,
                deleteAuthorProfileData: action.payload,
            };
        },
        deleteAuthorProfileFailure(state, action) {
            return {
                ...state,
                deleteAuthorProfileError: action.payload,
            };
        },
        deleteAuthorProfileResponse(state, action) {
            return {
                ...state,
                deleteAuthorProfileDataLoading: false,
                deleteAuthorProfileData: null,
                deleteAuthorProfileError: null
            };
        },
    },
});

export const {
    getAuthorListingLoading,
    getAuthorListingSuccess,
    getAuthorListingFailure,
    clearAuthorListingResponse,
    getAuthorDataLoading,
    getAuthorDataSuccess,
    getAuthorDataFailure,
    clearAuthorDataResponse,
    getEntitySearchListLoading,
    getEntitySearchListSuccess,
    getEntitySearchListFailure,
    clearEntitySearchListResponse,
    getLocationDataLoading,
    getLocationDataSuccess,
    getLocationDataFailure,
    getUserDataLoading,
    getUserDataSuccess,
    getUserDataFailure,
    postAuthorProfileSuccess,
    postAuthorProfileFailure,
    clearPostAuthorProfileResponse,
    putAuthorProfileSuccess,
    putAuthorProfileFailure,
    clearPutAuthorProfileResponse,
    deleteAuthorProfileLoading,
    deleteAuthorProfileSuccess,
    deleteAuthorProfileFailure,
    deleteAuthorProfileResponse
} = authorSlice.actions;

export const getAuthorListing = (params) => {
    return async (dispatch) => {
        dispatch(getAuthorListingLoading());
        await getAuthorListingRepo(params)
            .then((response) => {
                if (response?.status == 200) {
                    dispatch(getAuthorListingSuccess(response?.data?.data));
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(getAuthorListingFailure(error.message));
                }
            });
    };
};

export const getAuthorData = (params) => {
    return async (dispatch) => {
        dispatch(getAuthorDataLoading());
        await getAuthorDataRepo(params)
            .then((response) => {
                if (response?.status == 200) {
                    dispatch(getAuthorDataSuccess(response?.data?.data));
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(getAuthorDataFailure(error.message));
                }
            });
    };
};

export const getEntitySearchList = (params) => {
    return async (dispatch) => {
        dispatch(getEntitySearchListLoading());
        await getAuthorFilterRepo(params)
            .then((response) => {
                if (response?.status == 200) {
                    dispatch(getEntitySearchListSuccess(response?.data?.data));
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(getEntitySearchListFailure(error.message));
                }
            });
    };
};

export const getLocationData = (params) => {
    return async (dispatch) => {
        dispatch(getLocationDataLoading());
        await getLocationDataRepo(params)
            .then((response) => {
                if (response?.status == 200) {
                    dispatch(getLocationDataSuccess(response?.data?.data));
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(getLocationDataFailure(error.message));
                }
            });
    };
};

export const getUserData = (params) => {
    return async (dispatch) => {
        dispatch(getUserDataLoading());
        await getAuthorFilterRepo(params)
            .then((response) => {
                if (response?.status == 200) {
                    dispatch(getUserDataSuccess(response?.data?.data));
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(getUserDataFailure(error.message));
                }
            });
    };
};

export const postAuthorProfile = (data) => {
    return async (dispatch) => {
        await postAuthorProfileRepo(data)
            .then((response) => {
                if (
                    response?.status == 200 ||
                    response?.status == 201 ||
                    response?.status == 302
                ) {
                    dispatch(postAuthorProfileSuccess(response?.data?.data));
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(postAuthorProfileFailure(error.response?.data?.data));
                }
            });
    };
};

export const putAuthorProfile = (id, data) => {
    return async (dispatch) => {
        await putAuthorProfileRepo(id, data)
            .then((response) => {
                if (
                    response?.status == 200 ||
                    response?.status == 201 ||
                    response?.status == 302
                ) {
                    dispatch(putAuthorProfileSuccess(response?.data?.data));
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(putAuthorProfileFailure(error.message));
                }
            });
    };
};

export const deleteAuthorProfile = (id, data) => {
    return async (dispatch) => {
        dispatch(deleteAuthorProfileLoading());
        await deleteAuthorProfileRepo(id, data)
            .then((response) => {
                if (
                    response?.status == 200
                ) {
                    dispatch(deleteAuthorProfileSuccess(response?.data?.data));
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(deleteAuthorProfileFailure(error.message));
                }
            });
    };
};

export default authorSlice.reducer;
